<template>
<div class="chapter">
<div class="inner_page">
      ﻿

<title>Exiles</title>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<link href="9780374150976.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=utf-8" http-equiv="content-type"/>
<div class="contents" id="con01">
<h2 class="contentsHead"><span class="bold"><em class="italic">CONTENTS</em></span></h2>
<div class="contentsEntry">
<p class="contentsEntryName"><a href="#/9780374150976_fm01#fm01"><em class="italic">Author’s Note</em></a></p></div>
<div class="contentsEntry">
<p class="contentsEntryName"><a href="#/9780374150976_pt01#pt01"><span class="bold"><em class="italic">EXILES</em></span></a></p></div>
<div class="contentsEntry">
<p class="contentsEntryName"><span href="#/9780374150976_bm03#bm03" title="Link target outside of Sample"><em class="italic">Appendix</em> <em class="italic">“The Wreck of the Deutschland”</em></span></p> </div>
<div class="contentsEntry">
<p class="contentsEntryName"><span href="#/9780374150976_bm04#bm04" title="Link target outside of Sample"><em class="italic">A Note on Sources</em></span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780374150976_con01.vue?315cae44